const allowedPaymentMethods = [
	"CREDIBANCO",
	"TRANSFERENCIA",
	"EFECTIVO",
	"CONSIGNA",
	"CRÉDITO",
	"CRUCE",
	"CARTERA",
	"DATÁFONO",
];

const allowedDeliveryMethods = [
	"DOMICILIO",
	"TIENDA",
	"DIGITAL",
	"VENTA DIRECTA",
	"INSTITUCION",
];

const storeNit = 900699677;
const storeName = "Wisdom SAS";

export default {
	allowedPaymentMethods,
	multipleOrdersAllowedPaymentMethods: [
		allowedPaymentMethods[1],
		allowedPaymentMethods[2],
		allowedPaymentMethods[3],
		allowedPaymentMethods[4],
		allowedPaymentMethods[7],
	],
	institutionalAllowedPaymentMethods: [
		allowedPaymentMethods[3],
		allowedPaymentMethods[4],
		allowedPaymentMethods[5],
		allowedPaymentMethods[6],
	],
	defaultAllowedPaymentMethods: [
		allowedPaymentMethods[0],
		allowedPaymentMethods[1],
	],
	allowedDeliveryMethods,
	defaultAllowedDeliveryMethods: [
		allowedDeliveryMethods[0],
		allowedDeliveryMethods[1],
		allowedDeliveryMethods[2],
	],
	allowedPaymentMethodsMap: {
		CREDIBANCO: "PSE o Tarjeta de crédito",
		TRANSFERENCIA: "Transferencia/Consignación",
		EFECTIVO: "Efectivo",
		CRÉDITO: "Crédito",
		CONSIGNA: "Consigna",
		CRUCE: "Cruce",
		CARTERA: "Cartera",
		DATÁFONO: "Datáfono",
	},
	allowedDeliveryMethodsMap: {
		DOMICILIO: "Domicilio",
		TIENDA: "Tienda Wisdom",
		DIGITAL: "Digital",
		"VENTA DIRECTA": "Venta Directa",
		INSTITUCION: "Institución Educativa",
	},
	confirmedStatus: [
		"Pago exitoso",
		"Pedido exitoso",
		"Alistando pedido",
		"En proceso de entrega",
		"Entregado",
		"Pedido masivo generado",
		"Pedido masivo entregado",
	],
	orderTypes: ["PARTICULAR", "INSTITUCIONAL"],
	identificationTypes: ["CC", "TI", "NIT", "CE"],
	identificationTypesCodes: {
		CC: "13",
		TI: "12",
		NIT: "31",
		CE: "22",
	},
	invoiceTypes: {
		14: "POS - 14",
		1240: "Electrónica - 1240",
	},
	allowedPaymentMethodsGuidelines: {
		TRANSFERENCIA: `<p class="mb-2">
		<span class="text-info">**</span> Una vez realices el pago
		deberás cargar en la plataforma un comprobante del mismo</p>`,
		EFECTIVO: `<p class="mb-2">
		<span class="text-info">*</span> El pago se realiza al momento
		de recoger el pedido
	    </p>`,
		DATÁFONO: `<p class="mb-2">
		<span class="text-info">*</span> El pago se realiza al momento
		de recoger el pedido
	    </p>`,
	},
	initialAllowedPaymentMethodsGuidelines: {
		TRANSFERENCIA: `<p class="mb-2">
		<strong>- Titular:</strong> ${storeName}<br><strong>- NIT o número de documento:</strong> ${storeNit}</p>`,
	},
	allowedPaymentMethodsShowBanks: {
		TRANSFERENCIA: true,
	},
	allowedPaymentMethodsSelectBanks: {
		TRANSFERENCIA: true,
		EFECTIVO: true,
	},
	directAllowedPaymentMethods: [allowedPaymentMethods[0]],
	creditAllowedPaymentMethods: [
		allowedPaymentMethods[3],
		allowedPaymentMethods[4],
		allowedPaymentMethods[5],
		allowedPaymentMethods[6],
		allowedPaymentMethods[7],
	],
	supportedRoles: [
		"Superusuario",
		"Parametrización",
		"Gestión",
		"Transporte",
		"Cajero",
		"Call center",
		"Consulta",
		"Institucional",
		"Asesor",
	],
	defaultInstitutionDeliveryMessage: `Puedes recoger tu pedido en la sede principal de tu institución`,
	bankAccountTypes: ["", "Ahorros", "Corriente", "CARD", "PSE", "TOKEN_PAY"],
	bankAllowedAlias: ["", "caja", "banco", "cxc", "amortcxp"],
	supportedAddressFirstLine: [
		{ value: "Avenida", text: "Avenida" },
		{ value: "Avenida calle", text: "Av. Calle" },
		{ value: "Avenida carrera", text: "Av. Carrera" },
		{ value: "Calle", text: "Calle" },
		{ value: "Carrera", text: "Carrera" },
		{ value: "Diagonal", text: "Diagonal" },
		{ value: "Kilómetro", text: "Kilómetro" },
		{ value: "Manzana", text: "Manzana" },
		{ value: "Transversal", text: "Transversal" },
	],
	integrationInvoiceNotAllowedPaymentMethods: [allowedPaymentMethods[3]],
	additionalRequiredDataPaymentMethods: {
		CRUCE: {
			label: "Anticipo generado",
			name: "generatedAdvance",
		},
	},
	paymentWaysMap: {
		CARD: "Tarjeta",
		TOKEN_PAY: "Token de pago",
	},
	storeNit,
	storeName,
	customOrderDeliveryMethod: "CORTE DE CONSIGNA",
	zoneInstitution: [
		"BARRANQUILLA",
		"BOGOTA",
		"BUCARAMANGA",
		"CALI",
		"CARTAGO",
		"CAUCA",
		"CENTRAL",
		"CENTRO",
		"CHIA",
		"CORDOBA",
		"COSTA",
		"CUNDINAMARCA",
		"EJE",
		"EJE CAFETERO",
		"FLORIDABLANCA",
		"GIRARDOT",
		"IBAGUE",
		"LA GUAJIRA",
		"MANIZALES",
		"MONTERIA",
		"MOSQUERA",
		"NARIÑO",
		"NEIVA",
		"PALMIRA",
		"PEREIRA",
		"RISARALDA",
		"SAN GIL",
		"SANTANDER",
		"TUNJA",
		"VALLE",
		"VENEZUELA",
		"VILLAVICENCIO",
	],
	institutionType: [
		"CANAL",
		"COLEGIO",
		"CORPORATIVO",
		"DOCENTE",
		"LIBRERIA",
		"PARTICULAR",
		"PLS",
		"UNIVERSIDAD",
	],
	stateInstitution: [
		"ACTIVO",
		"INACTIVO",
		"MANTENIMIENTO",
		"NUEVO",
		"PERDIDO",
		"RETOMA",
		"SIN IDENTIFICAR",
	],
	saleType: [
		"AL DETAL",
		"CANAL",
		"CONSIGNA",
		"CONSIGNA INSTITUCIONAL",
		"CONSIGNACION INSTITUCIONAL",
		"CONTADO",
		"CONTADO/ PAPELERIA",
		"DIRECTA Y STORE",
		"INSTITUCIONAL",
		"INSTITUCIONAL EN CONSIGNA",
		"INSTITUCIONAL FACTURADO",
		"PAPELERIA",
		"SIN IDENTIFICAR",
		"STORE",
		"STORE E INSTITUCIONAL",
		"STORE INSTITUCIONAL",
		"STORE PARTICULAR",
		"STORE-LIBRERIA-VENTA DIRECTA",
		"VENTA DIRECTA",
	],
};
